// src/components/Navbar.tsx
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemText,
  useMediaQuery,
  useTheme,
  Box,
  ListItemButton,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navItems = ["Home", "Services", "Infrastructure", "About", "Contact"];

  return (
    <AppBar position="sticky" color="inherit" elevation={1}>
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontWeight: 900, color: "primary.main" }}>
            NETCOMSERVE
          </Typography>

          {isMobile ? (
            <>
              <IconButton onClick={() => setOpen(true)}>
                <MenuIcon />
              </IconButton>
              <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
                <List sx={{ width: 250 }}>
                  {navItems.map((text) => (
                    <ListItemButton key={text} onClick={() => setOpen(false)}>
                      <ListItemText primary={text} />
                    </ListItemButton>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            <Box>
              {navItems.map((item) => (
                <Button key={item} color="inherit" sx={{ ml: 2 }}>
                  {item}
                </Button>
              ))}
              <Button variant="contained" color="secondary" sx={{ ml: 3 }}>
                24/7 Support
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
